import React from 'react'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { CompetencyDescription } from 'components/shared/CompetencyDescription/CompetencyDescription'
import { CompetenciesFormFields } from 'components/shared/CompetenciesFormFields/CompetenciesFormFields'
import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'
import { DefaultDescription } from './common/DefaultDescription/DefaultDescription'

import {
  getCategoryOrder,
  getCompetencies,
  getIsCompetenciesDisabled,
} from 'components/shared/CompetenciesFormFields/helpers'
import { useActiveCategory } from 'hooks'

import styles from './Competencies.module.scss'

export const Competencies = ({
  control,
  competencies: { fields },
  formState,
  language,
}) => {
  const categories = getCompetencies(fields, language)
  const categoryOrder = getCategoryOrder(language)
  const isCompetenciesDisabled = getIsCompetenciesDisabled(formState)

  const {
    output: activeCategory,
    handleOutputChange,
    handleReset,
    hasOutput: hasActiveCategory,
  } = useActiveCategory()

  return (
    <div>
      <h3
        className={styles.subtitle}
      >{t`Click on the competence to read more about it`}</h3>
      <Box className={styles.competencies}>
        <Box className={styles.categories} direction="column" shouldWrapContent>
          <CompetenciesFormFields
            order={categoryOrder}
            onClick={handleOutputChange}
            {...{
              activeCategory,
              isCompetenciesDisabled,
              categories,
              control,
              formState,
            }}
          />
        </Box>
        <aside className={styles.aside}>
          <DetailsCard
            title={hasActiveCategory ? activeCategory : t`About competencies`}
            onBackClick={handleReset}
            hasDefaultState={!hasActiveCategory}
          >
            {hasActiveCategory ? (
              <CompetencyDescription
                competencies={
                  categories.reduce(
                    (
                      grouped,
                      { category, explanation, label, name },
                      index,
                    ) => {
                      if (!grouped[category]) {
                        grouped[category] = []
                      }

                      grouped[category].push({
                        explanation,
                        index,
                        label,
                        name,
                      })

                      return grouped
                    },
                    {},
                  )[activeCategory ?? '']
                }
              />
            ) : (
              <DefaultDescription />
            )}
          </DetailsCard>
        </aside>
      </Box>
    </div>
  )
}
